/**
 * Say that the Connect an editor page could not learn whether MCP is on, where
 * nobody would otherwise see it (review of !374): a refused read, a document
 * shaped unlike RFC 9728, no answer at all. The person sees "could not be
 * checked" and Try again; this is for whoever has to find out why. The same
 * shape as `notifications/report.ts`.
 */
export function reportEditorAccessProblem(
  message: string,
  context: Record<string, unknown>,
): void {
  console.warn(`editor access: ${message}`, context);
}
